const second = 1000;
const minute = 60 * second;
const hour = 60 * minute;
const day = 24 * hour;

export function calculateDifference(date: string) {
	const now = new Date();
	const target_date = new Date(date);
	const distance = target_date.getTime() - now.getTime();
	if (distance <= 0) {
		return { days: 0, hours: 0, minutes: 0, seconds: 0 };
	}
	const days = Math.floor(distance / day);
	const hours = Math.floor((distance - days * day) / hour);
	const minutes = Math.floor((distance - days * day - hours * hour) / minute);
	const seconds = Math.floor(
		(distance - days * day - hours * hour - minutes * minute) / second
	);
	return { days, hours, minutes, seconds };
}
